import { useMutation } from '@tanstack/react-query';

import { sdk } from '@/services';

const QuizService = sdk.getService('QuizService');

export const useCreateRetryWrongStudentQuizFromQuizResult = () => {
  const { mutateAsync: createRetryWrongStudentQuizFromQuizResult, isPending: isWorking } =
    useMutation({
      mutationFn: (quizResultId: string) =>
        QuizService.createRetryWrongStudentQuizFromQuizResult(quizResultId)
    });

  return {
    createRetryWrongStudentQuizFromQuizResult,
    isWorking
  };
};
